import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { styles } from '../view/styles';

export class CardHistoryWebComponent extends LitElement {
  // see https://lit-element.polymer-project.org/guide/properties

  @property({ type: String, attribute: true, reflect: true })
  name = '';

  @property({ type: String, attribute: true, reflect: true })
  date = '';

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    return html`
      <div class="wrapper d-flex flex-column">
        <div class="header-container d-flex flex-row justify-center align-items-center mb-1">
          <gz-title id="name">${this.name}</gz-title>
          <gz-text id="date" class="text-end">${this.date}</gz-text>
        </div>
        <div class="description">
          <slot></slot>
        </div>
      </div>
    `;
  }
}
